import { theme } from '@agilize/components-core';
import { device } from '@styles/tools/breakpoints.styles';
import { css, keyframes } from 'styled-components';

const shakeAnimation = keyframes`
10%{
transform: rotate(-10deg);
}
50% {
transform: rotate(10deg);

}
100% {
transform: rotate(0deg);

}`;
export const trumpsUtilities = () => css`
  .centered-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    &__full {
      flex: 1;
    }
  }

  .hide {
    &-mobile {
      ${device.mobile} {
        display: none;
      }
    }

    &-desktop {
      ${device.desktop} {
        display: none;
      }
    }
  }

  .buttons-container {
    display: flex;
    align-items: center;
    padding-top: ${props => props.theme.global.gutterSpace * 1.25}px;

    &--modal {
      justify-content: flex-end;
    }

    &--space-between {
      justify-content: space-between;
    }

    button,
    div {
      margin-right: ${props => props.theme.global.gutterSpace}px;
      &:last-child {
        margin-right: 0;
      }

      button {
        width: 100%;
      }
    }

    &--mobile-column {
      ${device.mobile} {
        flex-flow: column wrap;

        button {
          margin-right: 0;
          margin-bottom: ${props => props.theme.global.gutterSpace}px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    &--mobile-column-reverse {
      ${device.mobile} {
        flex-flow: column-reverse;

        button {
          margin-right: 0;
          margin-bottom: ${props => props.theme.global.gutterSpace}px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    &--mobile-column-table {
      padding-top: 0;
      width: 100%;
      ${device.mobile} {
        flex-flow: column wrap;

        button {
          margin-right: 0;
          margin-bottom: ${props => props.theme.global.gutterSpace}px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .tooltip-nav-bar {
    width: 90%;
  }

  .hide-not-desktop {
    display: none;
    ${device.desktop} {
      display: block;
    }
  }

  .default-font {
    font-family: ${theme.global.defaultFont};
  }

  .secondary-font {
    font-family: ${theme.global.secondaryFont};
  }

  .agilize-table__thead,
  .agilize-table__tbody {
    .table-col {
      &--5 {
        width: 5%;
      }
      &--10 {
        width: 10%;
      }
      &--15 {
        width: 15%;
      }
      &--20 {
        width: 20%;
      }
      &--25 {
        width: 25%;
      }
      &--30 {
        width: 30%;
      }
      &--35 {
        width: 35%;
      }
      &--40 {
        width: 40%;
      }
      &--45 {
        width: 45%;
      }
      &--50 {
        width: 50%;
      }
      &-align {
        &--right {
          text-align: right;
        }
        &--left {
          text-align: left;
        }
        &--center {
          text-align: center;
        }
      }
    }
  }

  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  .styled-scrollbar {
    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: ${props => props.theme.colors.grey100};
      border-radius: ${props => props.theme.forms.borderRadius}px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${props => props.theme.colors.grey400};
      border-radius: ${props => props.theme.forms.borderRadius}px;
      &:hover {
        background: ${props => props.theme.colors.grey700};
      }
    }
  }

  .shake-animation {
    animation: ${shakeAnimation} 1s;
  }

  .input-line-through {
    && ~ div > span {
      text-decoration: line-through;
    }
    &[role='combobox'] div:nth-child(3) {
      text-decoration: line-through;
    }
  }
`;
